//declarations
// import tabInterfaceInit from "./functions/tabs";
import modalInit from "./functions/modal";
import deviceTest from "./functions/deviceTest";
// import customSelect from "./functions/customSelect";
// import vehiclePageInit from "./pages/vehicle-page";
// import textarea from "./functions/textarea";
import carousel from "./functions/carousel";
import carouselLatestInBlog from "./functions/carousel/carousel-latest-in-blog";
import mobileNav from "./functions/mobile-nav";
// import integer from "./functions/integer";
// import pins from "./functions/pins";
// import rangeSlider from "./functions/range-slider";
// import widgetTestimonialsInit from './widgets/testimonials';
// import sharing from './functions/sharing';
// import countdownTimer from './functions/countdown-timer';
// import openMore from './functions/open-more';
// import anchors from './functions/anchors';
// import phoneMask from './functions/phone-mask';
// import validation from './functions/validation';
// import map from './functions/map';
import searchVehicle from './functions/search';
// import image360Controls from './functions/360';
// import videoStop from './functions/youtube';
// import marketSlideHover from './functions/market-slide';
// import integerShiftCount from "./functions/integerShiftCount";
// import homeSliderInit from "./widgets/home-slider";
// import homeAboutInit from "./widgets/home-about";
import { updateLocaleLink } from './helpers';

export default function appInit() {

    const app = this,
        $window = $(window),
        $html = $('html'),
        $wrapper = $('.wrapper');

    app.breakpoints = {
        xs: 320,
        sm: 480,
        tb: 768,
        md: 1024,
        lg: 1200
    };

    app.breakpointCurrent = [null, null];
    app.windowSize = [
        {
            width: 0,
            height: 0
        },
        {
            width: 0,
            height: 0
        }
    ];
    
    app.isMobile = false;
    app.mobileTest = function () {
        if (app.deviceTest.any() !== null) {
            app.isMobile = true;
            $html.addClass('_layout-mobile').removeClass('_layout-desktop');

            $('[data-content-mobile]').each(function () {
                let $this = $(this);
                $this.text($this.data('content-mobile'));
            });

            if(app.deviceTest.iOS() !== null) {
                $('html').toggleClass('_os-ios', true);
            }
        }
        else {
            app.isMobile = false;
            $html.addClass('_layout-desktop').removeClass('_layout-mobile');

            $('[data-content-desktop]').each(function () {
                var $this = $(this);
                $this.text($this.data('content-desktop'));
            });

            $('html').toggleClass('_os-ios', false);
        }
    };

    app.helpers = {};

    app.init = function () {
        // app.tabInterface = new tabInterfaceInit();
        app.modalInterface = new modalInit();
        app.deviceTest = new deviceTest();
        // app.pins= new pins();
        // app.customSelect = new customSelect();
        // app.textareaSymbolCount = new textarea();
        // app.integer = new integer();
        app.carousel= new carousel();
        app.mobileNav= new mobileNav();
        // app.rangeSlider= new rangeSlider();
        // app.sharing= new sharing();
        // app.countdownTimer = new countdownTimer();
        // widgetTestimonialsInit();
        // app.homesliders = new homeSliderInit();
        // homeAboutInit();

        breakpointInit();

        app.mobileTest();

        // new vehiclePageInit();

        windowSizeInit();

        handlerResize();

        // countdownTimer();

        // openMore();

        // anchors();

        // phoneMask();

        // validation();

        // map();

        searchVehicle();

        // image360Controls();

        // videoStop();

        // marketSlideHover();

        // customPaginationStyles();

        app.helpers.updateLocaleLink = updateLocaleLink;

        // events
        $window.on('resize', handlerResize);

        $window.on('scroll', handlerScroll);

        // $('[data-scrollto]').on('click', handlerScrollTo);

        $('[data-lang-switch]').on('click', languageSwitcher);

        // $('.tag-line__close').on('click', redirectUrl);

        $('body').on('click', handlerBodyClick);

        $('[data-nav-toggle]').on('click', toggleParentActiveClass);

        // $('.action-link--more, .stock-content').on('mouseover click', showMoreStock);

        // $('.action-link--more, .stock-content').on('mouseleave', hideMoreStock);

        // $('[data-open-filter]').on('click', openMobileFilters);

        // $('[data-close-filter]').on('click', closeMobileFilters);

        // $('[data-reset-filter]').on('click', resetMobileFilters);

        // $('.tag-line__tag--action').on('click', preventDefault);

        // $('.sales-card-big__wrap .link-overlay').on('mouseenter', addParentActiveClass);

        // $('.sales-card-big__wrap .link-overlay').on('mouseleave', removeParentActiveClass);

        $('[data-market-tab]').on('click', function () {
            $(this).parents('.product-subheader--mobile').find('.product-subheader__hidden-content').toggleClass('_active')
        });

        $('.beta-test').on('click', function () {
            $(this).toggleClass('_active');
        });

        $('.product-char table').each(function () {
            $(this).wrapAll('<div class="product-char__table" />');
        });

        if (!$('.section-hero--with-card').next('.hero-card').length) {
            $('.section-hero--with-card').removeClass('section-hero--with-card');
        }

        // $('.search-filters').on('click', '.checkbox-line__hidden-container + .btn--more', function (e) {
        //     e.preventDefault();
        //     $(this).prev('.checkbox-line__hidden-container').addClass('_active');
        // });

        // $('.search-filters').on('click', '.checkbox-line__hidden-container > .btn--less', function (e) {
        //     e.preventDefault();
        //     $(this).parents('.checkbox-line__hidden-container').removeClass('_active');
        // });

        /*$('.tag-line__tag').each(function () {
            if($(this).length > 0) {
                if ($(this).attr('href').length === 0) {
                    $(this).addClass('_disabled');
                }
            }
        });*/

        // $(document).on('click', '.promo-code__ico', function () {
        //     $(this).parents('.promo-code').toggleClass('_active');
        // });

        // $('.team-card__image').on('mouseenter', function () {
        //     if ($(this).find('.picture-hovered img').attr('src').length != 0 && $(window).innerWidth() > 1024) {
        //         $(this).addClass('_active');
        //     }
        // });

        // $('.team-card__image').on('mouseleave', function () {
        //     if ($(this).find('.picture-hovered img').attr('src').length != 0 && $(window).innerWidth() > 1024) {
        //         $(this).removeClass('_active');
        //     }
        // });

        // $('.team-card__image').on('click', function (e) {
        //     let $this = $(this);
        //     if ($this.find('.picture-hovered img').attr('src').length != 0 && $(window).innerWidth() <= 1024) {
        //         $('.team-card__image').not(this).removeClass('_active');
        //         $(this).toggleClass('_active');
        //     }
        // });

        // $('.faq').removeClass('_active');
    };

    //init
    app.init();

    // Copyright
    document.oncopy = function () {
        let bodyElement = document.body,
            selection = getSelection(),
            href = document.location.href,
            textPre = translations!==undefined ? translations.common_copyright_text_pre : 'Текст скопійований',
            textPost = translations!==undefined ? translations.common_copyright_text_post : 'Детальніше на:',
            copyright = textPre + ' ' + selection + ' ' + textPost + ' ' + "<a href='"+ href +"'>" + href + "</a>",
            text = copyright,
            divElement = document.createElement('div');
        divElement.style.position = 'absolute';
        divElement.style.left = '-99999px';
        divElement.innerHTML = text;
        bodyElement.appendChild(divElement);
        selection.selectAllChildren(divElement);
        setTimeout(function() { bodyElement.removeChild(divElement);
        }, 0);
    };

    // for (const el of document.querySelectorAll("[data-pattern][data-slots]")) {
    //     const pattern = el.getAttribute("data-pattern"),
    //         slots = new Set(el.dataset.slots || "_"),
    //         prev = (j => Array.from(pattern, (c,i) => slots.has(c)? j=i+1: j))(0),
    //         first = [...pattern].findIndex(c => slots.has(c)),
    //         accept = new RegExp(el.dataset.accept || "\\d", "g"),
    //         clean = input => {
    //             input = input.match(accept) || [];
    //             return Array.from(pattern, c =>
    //                 input[0] === c || slots.has(c) ? input.shift() || c : c
    //             );
    //         },
    //         format = () => {
    //             const [i, j] = [el.selectionStart, el.selectionEnd].map(i => {
    //                 i = clean(el.value.slice(0, i)).findIndex(c => slots.has(c));
    //                 return i<0? prev[prev.length-1]: back? prev[i-1] || first: i;
    //             });
    //             el.value = clean(el.value).join``;
    //             el.setSelectionRange(i, j);
    //             back = false;
    //         };
    //     let back = false;
    //     el.addEventListener("keydown", (e) => back = e.key === "Backspace");
    //     el.addEventListener("input", format);
    //     el.addEventListener("focus", format);
    //     el.addEventListener("blur", () => el.value === pattern && (el.value=""));
    // }

    // $('.input-phone').on('focus click', function () {
    //     let $this = $(this),
    //         phoneReg = /^\+38 \(___\) ___-__-__$/;
    //     if (phoneReg.test($this.val())) {
    //         $this[0].setSelectionRange(5, 5);
    //     }
    // });


    // handlers
    function handlerResize(event) {
        app.windowSize[1] = app.windowSize[0];
        app.windowSize[0] = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        app.breakpointCurrent[1] = app.breakpointCurrent[0];
        app.breakpointCurrent[0] = breakpointDetect();

        if (app.breakpointCurrent[0] !== app.breakpointCurrent[1]) {
            if (app.breakpointCurrent[1] === 'lg') {
            }
            if (app.breakpointCurrent[0] === 'xs') {
            }
            else if (app.breakpointCurrent[0] !== 'xs') {
            }
        }

        if (app.isMobile === true) {
            // $('.modal-wrap').css({height: window.innerHeight});
        }
        app.mobileTest();
    }

    function handlerScroll(event) {

    }

    function breakpointDetect() {
        var breakpointCurrent = '';
        for (var key in app.breakpoints) {
            if (app.windowSize[0].width >= app.breakpoints[key] && app.windowSize[1].width < app.breakpoints[key]) {
                breakpointCurrent = key;
                return breakpointCurrent;
            }
            else if (app.windowSize[0].width >= app.breakpoints[key]) {
                breakpointCurrent = key;
            }
        }
        return breakpointCurrent;
    }

    function breakpointInit() {
        let previousKey,
            i = 0;
        for (let key in app.breakpoints) {
            if (i !== 0) {
                if (window.innerWidth >= app.breakpoints[previousKey] && window.innerWidth < app.breakpoints[key]) {
                    app.breakpointCurrent = [previousKey, previousKey];
                    break;
                }
            }
            previousKey = key;
            i++;
        }
    }

    function windowSizeInit() {
        app.windowSize[0] = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        app.windowSize[1] = app.windowSize[0];
    }

    function handlerScrollTo(event) {
        let $this = $(this),
            selector = $this.data('scrollto'),
            $targetEl = $('[data-scroll-target='+selector+']');
        $('html, body').animate({
            scrollTop: $targetEl.offset().top
        }, 600);
    }

    function languageSwitcher(event) {
        let $target = $(event.target);
        if ($target.hasClass('_current')) {
            event.preventDefault();
        }
        $(this).toggleClass('_active');
    }

    function handlerBodyClick(event) {
        let $target = $(event.target);
        if ($target.hasClass('lang-switch _current')) {
            return true;
        }
        else {
            $('[data-lang-switch]').removeClass('_active');
        }
    }

    function toggleParentActiveClass() {
        $(this).parent().toggleClass('_active');
    }

    function addParentActiveClass() {
        $(this).parents('.sales-card-big').addClass('_active');
    }

    function removeParentActiveClass() {
        $(this).parents('.sales-card-big').removeClass('_active');
    }

    function redirectUrl(e) {
        e.preventDefault();
        window.location = $(this).data('url');
        $(this).parent().remove();
    }

    function showMoreStock() {
        $(this).parent('.stock').addClass('_active');
    }

    function hideMoreStock() {
        $(this).parent('.stock').removeClass('_active');
    }

    function openMobileFilters() {
        $('[data-mobile-filter]').addClass('_active');
        $('body').addClass('_overflow-hidden');
    }

    function closeMobileFilters() {
        $('[data-mobile-filter]').removeClass('_active');
        $('body').removeClass('_overflow-hidden');
    }

    function resetMobileFilters() {
        $('[data-mobile-filter]').removeClass('_active');
        $('body').removeClass('_overflow-hidden');
        $('.search-filters').trigger('reset');
    }

    function preventDefault(e) {
        e.preventDefault();
    }

    // function customPaginationStyles() {
    //     if ($('.pagination .page-item').length < 7) {
    //         $('.pagination').addClass('pagination--7');
    //     } else {
    //         $('.pagination').removeClass('pagination--7');
    //     }
    // }


}